import MasterApi from './MasterApi';

export default class TankDetail extends MasterApi {
  constructor() {
    super();
    this.masterName = 'tank_detail';
  }
}
